import { RefObject, useEffect } from 'react'

type attributesType = {
    [key: string]: string | number
}

export const useCustomAttributes = (ref: RefObject<HTMLElement>, attributes: attributesType) => {
    useEffect(() => {
        if (ref.current) {
            Object.entries(attributes).forEach(([key, value]) => {
                ref.current?.setAttribute(key, value.toString())
            })
        }
    }, [ref, attributes])
}
